import { useState } from "react"
import { toast } from "react-toastify"
import MyModal from "../MyModal"
import { useAuth } from "../../lib/useAuth"
import {
    connect,
    disconnect,
    extend,
    activate,
    suspend,
    reconnect,
    deleteRankSystem,
} from "../../services/ranksystemApis"
import EditRankSystemModal from "./EditRankSystemModa"

const RankSystemMoreModal = ({ ranksystem }) => {
    const { user } = useAuth()

    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button onClick={toggleModal}>
                <img className="w-5 h-5" src="assets/icons/gear-complex.svg" />
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="grid grid-cols-3">
                    <div className="col-span-2 mt-5 mr-5 ml-5   ">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>اسم تمپلیت</a>
                            <a className="float-left text-blue-400">{ranksystem.template_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>لینک</a>
                            <a
                                className="float-left text-blue-400"
                                target="_blank"
                                href={`https://ranksystem.${user.companyDomainName}/${ranksystem?.template_name}/webinterface`}
                            >{`https://ranksystem.${user.companyDomainName}/${ranksystem?.template_name}/webinterface`}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نام کاربری</a>
                            <a className="float-left text-blue-400">{ranksystem.username}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>پسورد</a>
                            <a className="float-left text-blue-400">{ranksystem.password}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>مالک</a>
                            <a className="float-left text-blue-400">{ranksystem.author}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ ساخت</a>
                            <a className="float-left text-blue-400">{ranksystem.crtString}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ انقضا</a>
                            <a className="float-left text-blue-400">
                                {ranksystem.expString ? (
                                    ranksystem.expires < 0 ? (
                                        <span class="text-sm font-medium text-red-500">{ranksystem.expString}</span>
                                    ) : (
                                        <span class="text-sm font-medium text-green-500">{ranksystem.expString}</span>
                                    )
                                ) : (
                                    <span class="text-sm font-medium">دائمی</span>
                                )}
                            </a>
                        </li>

                        <li className="py-2 border-b-2 border-t-2 border-slate-700 relative block">
                            <a>توضیحات</a>
                            <a className="float-left text-blue-400">{ranksystem.information}</a>
                        </li>
                    </div>
                    <div className="col-span-1 flex flex-col ">
                        <EditRankSystemModal ranksystem={ranksystem} />

                        <button
                            onClick={() => {
                                toast
                                    .promise(extend({ botId: ranksystem.id }), {
                                        pending: "در حال تمدید بات",
                                        success: "تمدید شد",
                                    })

                                    .catch((err) => {
                                        if (err?.response?.status == 410) {
                                            toast.error("موجودی کافی نمیباشد")
                                        } else {
                                            toast.error(err)
                                        }
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center gap-2 border border-green-500 bg-green-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            <p>تمدید</p>
                        </button>
                        <button
                            onClick={() => {
                                if (ranksystem.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }

                                toast
                                    .promise(connect({ botId: ranksystem.id }), {
                                        pending: "در حال کانکت",
                                        success: "کانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center gap-2 border border-green-500 bg-green-500 text-white rounded-3xl px-3 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/play.svg" width="20px" height="20px" />
                            کانکت
                        </button>
                        <button
                            onClick={() => {
                                toast
                                    .promise(disconnect({ botId: ranksystem.id }), {
                                        pending: "در حال دیسکانت",
                                        success: "دیسکانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center border gap-2 border-red-500 bg-red-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/power-off.svg" width="20px" height="20px" />
                            دیسکانکت
                        </button>

                        <button
                            onClick={() => {
                                if (ranksystem.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }

                                toast
                                    .promise(reconnect({ botId: ranksystem.id }), {
                                        pending: "در حال ریکانکت",
                                        success: "ریکانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center gap-2 border border-indigo-500 bg-indigo-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-indigo-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            ریکانکت
                        </button>
                        {ranksystem.state == "suspended" ? (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(activate({ botId: ranksystem.id }), {
                                            pending: "در حال فعال کردن بات",
                                            success: "فعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-green-500 bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect
                                        x="10.5"
                                        style={{ fill: "#f4f4f5", backgroundColor: "white" }}
                                        width="6"
                                        height="30"
                                    />
                                </svg>
                                فعال کردن
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(suspend({ botId: ranksystem.id }), {
                                            pending: "در حال غیرفعال کردن بات",
                                            success: "غیرفعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-yellow-500 bg-yellow-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                </svg>
                                غیرفعال کردن
                            </button>
                        )}
                        <button
                            onClick={() => {
                                toast
                                    .promise(deleteRankSystem({ botId: ranksystem.id }), {
                                        pending: "در حال حذف کردن بات",
                                        success: "حذف شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center gap-2 border border-red-500 bg-red-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/trash-can.svg" width="20px" height="20px" />
                            حذف
                        </button>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default RankSystemMoreModal
